import script from "./AiBottomModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AiBottomModal.vue?vue&type=script&lang=ts&setup=true"

import "./AiBottomModal.scss?vue&type=style&index=0&id=495fb5b2&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-495fb5b2"]])

export default __exports__